// ECRIT A LA MAIN (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Vignettes : une grille de deux carres sur deux, au trait.
 *
 * DESSINEE POUR CE CHANTIER (la carte des fichiers joints), pas fournie par le
 * fondateur. Meme cadre `0 0 24 24` et meme poids que `IconAjouterFichier` et
 * le dossier `IconNewFolder` : contour plein de 2.5 unites, quatre carres de
 * 10 unites separes de 2.5.
 */
export const IconVignettes = createCustomIcon(
  'IconVignettes',
  '0 0 24 24',
  <path
    fill="currentColor"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M.75.75h10v10h-10zm2.5 2.5v5h5v-5zM13.25.75h10v10h-10zm2.5 2.5v5h5v-5zM.75 13.25h10v10h-10zm2.5 2.5v5h5v-5zM13.25 13.25h10v10h-10zm2.5 2.5v5h5v-5z"
  />,
);
